import { useMutation } from '@tanstack/react-query';
import { useDialogs, useNotifications } from '@toolpad/core';
import { useNavigate } from 'react-router';
import {
    Card,
    CardContent,
    CardHeader,
    Stack,
    Typography,
} from '@mui/material';
import Button from '@mui/material/Button';

import Api from '@barboxx/api';
import { MenuItem } from '@barboxx/models';

interface Props {
    menuItem: MenuItem.DetailsResponse;
}

export const MenuItemDeleteCard = ({ menuItem }: Props) => {
    const notification = useNotifications();
    const navigate = useNavigate();
    const dialog = useDialogs();

    const mutateDeleteMenuItem = useMutation({
        mutationKey: ['deleteMenuItem', menuItem.id],
        mutationFn: () => Api.Menu.MenuItem.deleteMenuItem(menuItem),
    });

    const onDelete = async () => {
        const deleteConfirmed = await dialog.confirm(
            'Are you sure you want to Delete this Menu Item!',
            {
                severity: 'error',
                okText: 'Delete',
                title: 'Delete Menu Item',
            }
        );

        if (!deleteConfirmed) {
            return;
        }
        mutateDeleteMenuItem
            .mutateAsync()
            .then(({ data }) => {
                notification.show('Deleted menu item!', {
                    severity: 'success',
                });
                navigate(-1);
            })
            .catch(e => {
                notification.show('Error Deleting menu item!', {
                    severity: 'error',
                });
            });
    };

    return (
        <Card>
            <CardHeader title="Delete MenuItem" />
            <CardContent>
                <Stack gap={2} direction="row">
                    <Typography flex={1}>
                        Are you sure you want to Delete this menu item?
                    </Typography>

                    <Button onClick={onDelete} color="error" variant="outlined">
                        Delete
                    </Button>
                </Stack>
            </CardContent>
        </Card>
    );
};
